/**
 * Scroll Manager — saves and restores scroll positions per route.
 *
 * Storage: in-memory Map (no persistence across reloads).
 *
 * Policies:
 *   Forward navigation → route metadata
 *   Backward navigation → restore saved position
 *   Replace navigation → scroll top
 */

/** @type {Map<string, number>} */
const scroll_positions = new Map()

function get_scroller() {
  const route_root = document.querySelector('[data-route-content]')
  return route_root && /(auto|scroll)/.test(getComputedStyle(route_root).overflowY)
    ? route_root
    : window
}

/**
 * Save current scroll position for a route path.
 * @param {string} path
 */
export function saveScroll(path) {
  const scroller = get_scroller()
  scroll_positions.set(path, scroller === window ? window.scrollY : scroller.scrollTop)
}

/**
 * Restore saved scroll position for a route path, or start at the top when
 * this route has no history yet. Uses requestAnimationFrame for the DOM commit.
 * @param {string} path
 */
export function restoreScroll(path) {
  requestAnimationFrame(() => {
    get_scroller().scrollTo({ top: scroll_positions.get(path) ?? 0, behavior: 'instant' })
  })
}

/** Scroll to the top of the active route container. */
export function resetScroll() {
  get_scroller().scrollTo({ top: 0, behavior: 'instant' })
}

/** Clear all saved scroll positions. */
export function clearScroll() {
  scroll_positions.clear()
}
